import React from "react";

import { Container, Grid } from "@material-ui/core";
/*import { MultiShipmentLayout } from "./common/multishipment/MultiShipmentLayout";
 import { ImageViewer } from "./Utilities/ImageViewer";
import { MultiImageViewer } from "./Utilities/ImageViewer"; */

import Validators from "./Utilities/Validators";

export class Test extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  Validation = () => {
    console.log("40765149H", Validators.documentIdentification("40765149H"))
    console.log("Z5189465A", Validators.documentIdentification("Z5189465A"))
    console.log("F53427415", Validators.documentIdentification("F53427415"))

    console.log("40765149F", Validators.documentIdentification("40765149F"))
    console.log("Z5189465E", Validators.documentIdentification("Z5189465E"))
    console.log("F53427416", Validators.documentIdentification("F53427416"))
  }

  render() {
    return (
      <React.Fragment>
        <Container>
          <Grid container item md={12} direction="row" justift="center">
            {this.Validation()}
            {/* Testing image viewer component */}
           {/*  <ImageViewer
              documentpages={""}
              documentid={"cbc1de12-73a6-45fc-b15a-188a6c383ded"}
              pagenumber={1}
              totalpages={3}
              viewerWidth={500}
              viewerHeight={750}>
            </ImageViewer> */}

             {/*  <MultiImageViewer
                documentpages={this.state.documentpages}
                pagenumber={this.state.pagenumber}
                viewerWidth={750}
                viewerHeight={900}>
              </MultiImageViewer> */}

            {/* Testing multi-shipment component */}
           {/*  <MultiShipmentLayout
              documentsid={["cbc1de12-73a6-45fc-b15a-188a6c383ded", "002e16e1-c25a-44ef-9cdd-daf01357eb6a", "3e34394e-cb54-46ed-8b89-dcc294fcfad9"]}
            ></MultiShipmentLayout> */}
          </Grid>
        </Container>
        
      </React.Fragment>
    )
  }
  
}


// WEBPACK FOOTER //
// ./src/components/Test.js